import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Star } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Packages() {
  const [packages, setPackages] = useState([]);
  useEffect(() => { api.get("/packages").then((r) => setPackages(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="packages-page">
      <Seo
        title="Catering Packages & Pricing | K.O Chef & Catering — Naples FL"
        description="Browse our Silver, Gold, Platinum, Corporate Lunch and Wedding catering packages with transparent per-person pricing. Serving Naples, Bonita Springs & Fort Myers, FL."
        path="/packages"
      />
      <PageHero overline="Menu Packages" title="Signature Catering Packages"
        subtitle="Thoughtfully composed menus with transparent per-person pricing."
        image="https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-20 md:py-28">
        <div className="container-lux grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <div className={`border p-8 h-full flex flex-col relative ${p.featured ? "border-gold bg-gold/[0.04]" : "border-white/10"}`} data-testid={`package-${i}`}>
                {p.featured && <span className="absolute -top-3 left-8 bg-gold text-black text-[10px] uppercase tracking-widest px-3 py-1 flex items-center gap-1"><Star className="w-3 h-3 fill-black" />Most Popular</span>}
                <h3 className="text-2xl font-light text-white">{p.name}</h3>
                <p className="text-sm text-white/55 mt-3 leading-relaxed">{p.description}</p>
                <div className="my-6 py-6 border-y border-white/10">
                  <p className="text-4xl font-serif text-gold">${p.price_per_person}<span className="text-sm text-white/40"> / person</span></p>
                  <p className="text-xs text-white/40 mt-2">Minimum {p.min_guests} guests</p>
                </div>
                <ul className="space-y-3 mb-8 flex-1">
                  {p.menu.map((m) => (
                    <li key={m} className="flex items-start gap-3 text-sm text-white/70"><Check className="w-4 h-4 text-gold shrink-0 mt-0.5" />{m}</li>
                  ))}
                </ul>
                <Link to="/request-a-quote" className={p.featured ? "btn-gold w-full !py-3" : "btn-outline w-full !py-3"} data-testid={`package-quote-${i}`}>Request Quote</Link>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="container-lux text-center mt-16">
          <p className="text-white/50 mb-6">Prefer to design your own? Build a fully custom menu.</p>
          <Link to="/build-your-menu" className="btn-gold" data-testid="packages-build-btn">Build Your Own Menu</Link>
        </div>
      </section>
    </div>
  );
}
